

const ETAToRedeliveryAddress = {
  title: 'ETA to redelivery address',
  inputStyle: 'date',
  dataIndex: 'lvo_etatoredeliveryaddress',
  placeholder: 'Please select Date',
  valid: true,
  isOk: true,
  value: null,
  errorMsg: 'Please input a valid value'
}
const Cost = {
  title: 'Cost',
  dataIndex: 'lvo_cost',
  inputStyle: 'number',
  placeholder: 'In EUR, use format 15.5',
  value: '',
  isOk: true,
  valid: true,
  errorMsg: 'Please input a valid value'
}
const DeadlineOfApproval = {
  title: 'Deadline of approval',
  inputStyle: 'dateTime',
  dataIndex: 'lvo_deadlineforapproval',
  placeholder: 'Please select time Of Deadline',
  valid: true,
  isOk: true,
  value: '',
  errorMsg: 'Please input a valid value'
}

const NewETAforTheShipment = {
  title: 'New ETA for the shipment',
  inputStyle: 'date',
  dataIndex: 'lvo_newetaproposedbycarrier',
  placeholder: 'Please select time Of Deadline',
  valid: true,
  isOk: true,
  value: null,
  code: 'lvo_newetaproposedbycarrier',
  errorMsg: 'Please input a valid value'
}

const DateOfShipmentStopped = {
  title: 'Date of shipment stopped',
  inputStyle: 'date',
  dataIndex: 'lvo_dateofshipmentstopped',
  placeholder: 'Please select time Of Deadline',
  valid: true,
  isOk: true,
  value: null,
  code: 'lvo_dateofshipmentstopped',
  errorMsg: 'Please input a valid value'
}

const rejectionComments = {
  title: 'Rejection comments',
  inputStyle: 'textarea',
  dataIndex: 'lvo_rejectioncomments',
  placeholder: 'Please enter Comments',
  value: '',
  valid: true,
  isOk: true,
  code: 'lvo_comments',
  errorMsg: 'Please input a valid value'
}
const LocationOfStoppedShipment = {
  title: 'Location of stopped shipment',
  inputStyle: 'text',
  dataIndex: 'lvo_rejectioncomments',
  placeholder: 'Please enter Comments',
  value: '',
  valid: true,
  isOk: true,
  code: 'lvo_locationofstoppedshipment',
  errorMsg: 'Please input a valid value'
}
const ContactNameAtLocation = {
  title: 'Contact name at location',
  inputStyle: 'text',
  dataIndex: 'lvo_contactnameatlocation',
  placeholder: 'Please enter Comments',
  value: '',
  valid: true,
  isOk: true,
  code: 'lvo_contactnameatlocation',
  errorMsg: 'Please input a valid value'
}
const ContactPhoneAtLocation = {
  title: 'Contact phone at location',
  inputStyle: 'text',
  dataIndex: 'lvo_contactphoneatlocation',
  placeholder: 'Please enter Comments',
  value: '',
  valid: true,
  isOk: true,
  code: 'lvo_contactphoneatlocation',
  errorMsg: 'Please input a valid value'
}
const ContactEmailAtLocation = {
  title: 'Contact email at location',
  inputStyle: 'text',
  dataIndex: 'lvo_contactemailatlocation',
  placeholder: 'Please enter Comments',
  value: '',
  valid: true,
  isOk: true,
  code: 'lvo_contactemailatlocation',
  errorMsg: 'Please input a valid value'
}

const ReasonOfDelay = {
  title: 'Reason of delay',
  inputStyle: 'textarea',
  dataIndex: 'lvo_reasonofdelay',
  placeholder: 'Please enter Reason of delay',
  value: '',
  valid: false,
  isOk: true,
  code: 'lvo_reasonofdelay',
  errorMsg: 'Please input a valid value'
}
const currency = {
  title: 'Currency',
  inputStyle: 'select',
  placeholder: 'Please Select Currency',
  valid: true,
  isOk: true,
  code: 'transactioncurrencyid',
  errorMsg: 'Please input a valid value',
  value: [],
  selectArray: []
}

const attachment = {
  title: 'Attachment',
  inputStyle: 'upload',
  placeholder: '',
  valid: false,
  isOk: true,
  value: null,
  errorMsg: ''
}

const cleanpod = {
  title: 'Clean POD',
  name: '',
  inputStyle: 'checkbox',
  valid: true,
  isOk: true,
  value: '',
  code: 'lvo_cleanpod'
}
const warehousesearchcompleted = {
  title: 'Warehouse search completed',
  name: '',
  inputStyle: 'checkbox',
  valid: true,
  isOk: true,
  value: '',
  code: 'lvo_warehousesearchcompleted'
}

const consolidateddeliverynumbers = {
  title: 'Consolidated delivery numbers',
  inputStyle: 'textarea',
  dataIndex: 'lvo_consolidateddeliverynumbers',
  placeholder: 'Please enter Consolidated delivery numbers',
  value: '',
  valid: false,
  isOk: true,
  code: 'lvo_consolidateddeliverynumbers',
  errorMsg: 'Please input a valid value'
}

export const YOUR_RESPONSE_CONFIG = {
  lvo_etatoredeliveryaddress: ETAToRedeliveryAddress,
  lvo_cost: Cost,
  lvo_deadlineforapproval: DeadlineOfApproval,
  lvo_rejectioncomments: rejectionComments,
  lvo_reasonofdelay: ReasonOfDelay,
  lvo_newetaproposedbycarrier: NewETAforTheShipment,
  lvo_dateofshipmentstopped: DateOfShipmentStopped,
  lvo_locationofstoppedshipment: LocationOfStoppedShipment,
  lvo_contactnameatlocation: ContactNameAtLocation,
  lvo_contactphoneatlocation: ContactPhoneAtLocation,
  lvo_contactemailatlocation: ContactEmailAtLocation,
  lvo_cleanpod: cleanpod,
  lvo_warehousesearchcompleted: warehousesearchcompleted,
  lvo_consolidateddeliverynumbers: consolidateddeliverynumbers,
  transactioncurrencyid: currency
}


//   CarrierAcceptsRequest(552590000),
//   CarrierRejectsRequest(552590001),
//   CarrierAcceptsCFAcceptsDeliveryConfirmed(552590002),
//   CarrierAcceptsCFRejects(552590003),
//   CarrierAcceptsDeliveryConfirmed(552590004),
//   CarrierFault(552590005),
//   NotCarrierFault(552590006),
//   RequesterRejectedTheConditions(552590007),
//   RequesterAcceptedTheConditions(552590008),
//   ChangeOfAddressIsPossibleWithoutAnyCostAndTimeImpact(552590010),
//   ChangeOfAddressIsOnlyPossibleWithCostOrTimeImpact(552590011),
//   CarrierResponded(552590012),
//   CarrierDoubleAccept(552590009);

export const buttonTitleConfig = {
  552590000: 'Accept',
  552590001: 'Reject',
  552590002: 'Double Accept',
  552590003: '',
  552590004: 'Double Accept',
  552590005: 'Submit',
  552590006: 'Submit',
  552590007: '',
  552590008: '',
  552590009: 'Double Accept',
  552590010: 'Accept',
  552590011: 'Impact',
  552590012: 'Submit',
}

export const PDFFileConfig = {
  'dcg-cancellation in transit': '/cf/DCG- Cancellation in Transit',
  'dcg-change of address': '/cf/DCG- Change of Address',
  'dcg-coll & redel - lenovo request': '/cf/DCG- Coll & Redel - Lenovo request',
  'dcg-eta confirmation request': '/cf/DCG- ETA confirmation request',
  'dcg-incomplete partial delivery': '/cf/DCG- Incomplete Partial Delivery',
  'dcg-shipment did not on eta': '/cf/DCG- Shipment did not on ETA',
  'idg-cancellation in transit process map': '/cf/IDG- Cancellation in transit process map',
  'idg-change of address': '/cf/IDG- Change of Address',
}

